/** A referential list: no tenant, no parameter. */
class FetchSubjectTypeAccessLevels {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSubjectTypeAccessLevels;
